import {useEffect, useState} from "react";
import {ColumnTypes, Filters, SortOrders} from "../types";
import orderBy from 'lodash/orderBy';

export function useSortedAndFilteredData(rows: any, loading: boolean) {
  const [appFilter, setAppFilter] = useState("");
  const [formattedData, setFormattedData] = useState(rows);
  const [sort, setSort] = useState(ColumnTypes.APP);
  const [sortDirection, setSortDirection] = useState<any>(SortOrders.ASC);
  const [versionFilter, setVersionFilter] = useState("");

  const onSort = (property: ColumnTypes) => {
    if (loading) return [];
    let newDirection = sortDirection;

    newDirection = property !== sort ? SortOrders.ASC :
        newDirection === SortOrders.ASC ? SortOrders.DESC : SortOrders.ASC;

    setSort(property);
    setSortDirection(newDirection);

    if (!rows) setFormattedData([]);
  };

  const onFilterChange = (filters: Filters) => {
    console.log("onFilterChange", {filters})
    if (filters.name !== undefined){
      console.log("setting app filter to ", filters.name)
      setAppFilter(filters.name);
    }
    if (filters.version !== undefined) setVersionFilter(filters.version);
  };

  useEffect(() => {
    if (loading) {
      setFormattedData([]);
    } else {

      let newData = orderBy(rows, [sort], [sortDirection]);
      if (appFilter) {
        console.log("found appFilter", {appFilter})
        //  @ts-ignore
        newData = newData.filter((row) => row?.name.includes(appFilter));
      }
      if (versionFilter) {
        //  @ts-ignore
        newData = newData.filter((row) => row?.version.includes(versionFilter));
      }
      //  @ts-ignore
      setFormattedData(newData);
    }
  }, [loading, appFilter, versionFilter, sort, sortDirection, rows]);

  return {
    data: formattedData,
    filters: { name: appFilter, version: versionFilter } as Filters,
    onFilterChange,
    onSort,
    order: sortDirection,
    orderBy: sort,
  };
}
